// extracted by mini-css-extract-plugin
module.exports = {"label":"InputBirthdate_label__2T904","fields":"InputBirthdate_fields__20Mmy","field":"InputBirthdate_field__12RE_"};